import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import TextInput from "components/common/DTextField";
import PasswordInput from "components/common/PasswordInput";
import PrimaryButton from "components/common/DButton";

import { loginSchema } from "validation";
import useAuth from "hooks/useAuth";
import { Alert } from "@mui/material";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import { ROUTES } from "config";
import { Link } from "react-router-dom";

export default function LoginForm() {
    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting }
    } = useForm({
        resolver: yupResolver(loginSchema),
        defaultValues: {
            userName: "",
            password: ""
        }
    });

    const { signIn, error } = useAuth();

    const onSubmit = async (data) => {
        await signIn(data);
    };

    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <GridContainer direction="column" spacing={1}>
                {/* <GridItem>
                    <Typography variant="h5" mb={1}>
                        Welcome Back
                    </Typography>
                </GridItem>*/}
                <GridItem>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        mb={2}
                        sx={{ fontWeight: "bold" }}
                    >
                        Login to your account
                    </Typography>
                </GridItem>
                <GridItem>
                    <Controller
                        name="userName"
                        control={control}
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                label="User Name"
                                error={!!errors.userName}
                                helperText={errors.userName?.message}
                            />
                        )}
                    />
                </GridItem>
                <GridItem>
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                            <PasswordInput
                                {...field}
                                label="Password"
                                error={!!errors.password}
                                helperText={errors.password?.message}
                            />
                        )}
                    />
                </GridItem>
                <GridItem>
                    <Typography
                        mb={2}
                        // sx={{ display: "flex" }}
                        component={Link}
                        to={ROUTES.FORGOT_PASSWORD}
                        variant="body2"
                        color="primary"
                        sx={{
                            fontWeight: "bold",
                            paddingLeft: "4px",
                            textDecoration: "none",
                            cursor: "pointer"
                        }}
                    >
                        Forgot password?{" "}
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            mb={2}
                            sx={{ fontWeight: "bold", paddingLeft: "4px" }}
                        >
                            Click here
                        </Typography>
                    </Typography>
                </GridItem>
                {error && (
                    <GridItem>
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {error}
                        </Alert>
                    </GridItem>
                )}
                <GridItem sx={{ marginTop: "16px" }}>
                    <Box mt={3}>
                        <PrimaryButton type="submit" loading={isSubmitting}>
                            Sign In
                        </PrimaryButton>
                    </Box>
                </GridItem>
            </GridContainer>
        </Box>
    );
}
